import { render } from "./OddsFilter.vue?vue&type=template&id=4a801ea3&scoped=true"
import script from "./OddsFilter.vue?vue&type=script&lang=js"
export * from "./OddsFilter.vue?vue&type=script&lang=js"

import "./OddsFilter.vue?vue&type=style&index=0&id=4a801ea3&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a801ea3"]])

export default __exports__